var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0791 7.15V4.125H6.92081V7.15H5.54581V2.75H16.4541V7.15H15.0791ZM16.9354 10.7021C17.1187 10.7021 17.2791 10.6333 17.4166 10.4958C17.5541 10.3583 17.6229 10.1979 17.6229 10.0146C17.6229 9.83125 17.5541 9.67083 17.4166 9.53333C17.2791 9.39583 17.1187 9.32708 16.9354 9.32708C16.7521 9.32708 16.5916 9.39583 16.4541 9.53333C16.3166 9.67083 16.2479 9.83125 16.2479 10.0146C16.2479 10.1979 16.3166 10.3583 16.4541 10.4958C16.5916 10.6333 16.7521 10.7021 16.9354 10.7021ZM15.0791 17.875V13.475H6.92081V17.875H15.0791ZM16.4541 19.25H5.54581V15.2167H1.83331V9.57917C1.83331 8.8909 2.0663 8.31398 2.53227 7.84838C2.99824 7.38279 3.57498 7.15 4.26248 7.15H17.7375C18.4257 7.15 19.0027 7.38279 19.4683 7.84838C19.9339 8.31398 20.1666 8.8909 20.1666 9.57917V15.2167H16.4541V19.25ZM18.7916 13.8417V9.57424C18.7916 9.27197 18.6906 9.02153 18.4886 8.82292C18.2865 8.62431 18.0362 8.525 17.7375 8.525H4.26248C3.9638 8.525 3.71343 8.62602 3.51139 8.82807C3.30934 9.03012 3.20831 9.28049 3.20831 9.57917V13.8417H5.54581V12.1H16.4541V13.8417H18.7916Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.b09de6c247ea9db7bb6c0521fd4d5638.svg";
export { ForwardRef as ReactComponent };